import { Box, SvgIconProps } from '@rhg/libs/material';

// Some icons' underlying SVG embeds a large base64 bitmap (e.g. a
// photographic gradient disc) rather than pure vector paths. Importing one
// through the SVGR pipeline like the vector icons do would inline that
// whole multi-megabyte payload into the JS bundle - referencing it by its
// static `public/` path instead lets the browser fetch it as its own
// cacheable network asset, same as any other image.
export function createBitmapIcon(src: string) {
    return function BitmapIcon({ sx, ...rest }: SvgIconProps) {
        return (
            <Box
                component="img"
                src={src}
                alt=""
                aria-hidden={rest['aria-hidden']}
                sx={sx}
            />
        );
    };
}
